<template>
    <div class="px-6 pt-4 pb-2">
        <div class="mb-6 md:mb-0">
            <admin-app-label>Search</admin-app-label>
            <div class="relative">
                <input-basic
                    placeholder="Search"
                    :modelValue="modelValue"
                    @update:modelValue="$emit('update:modelValue', $event)"
                />
                <div class="absolute inset-y-0 right-0 flex items-center">
                    <admin-link @click="" type="reset" class="h-full bg-grey-100 text-dark border-solid border-2 border-grey-200" v-if="term">Reset</admin-link>
                    <admin-link type="submit" class="h-full">Search</admin-link>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AdminAppLabel from "@/Components/Admin/Forms/AdminAppLabel";
import AdminLink from "@/Components/Admin/AdminLink";
import InputBasic from "@/Components/Admin/Forms/Inputs/InputBasic";
export default {
    components: {
        AdminAppLabel,
        AdminLink,
        InputBasic
    },
    props: {
        term: String,
        modelValue: String
    },
    methods: {
        resetForm()
        {
            this.$refs.searchForm.reset();
        }
    }
}
</script>
